/**
 * @file Modal dialog component
 */

/**
 * Show a modal dialog.
 * @param {string} title
 * @param {string} content - HTML content
 * @param {Array<{label: string, onClick: Function, type?: string}>} [actions]
 */
export function showModal(title, content, actions = []) {
  const overlay = document.getElementById('modal-overlay');
  const container = document.getElementById('modal-content');
  if (!overlay || !container) return;

  const actionsHtml = actions.length > 0
    ? `<div class="modal-actions">${actions.map((a, i) =>
        `<button class="btn ${a.type === 'danger' ? 'btn-danger' : a.type === 'gold' ? 'btn-gold' : 'btn-outline'} btn-sm" data-action="${i}">${a.label}</button>`
      ).join('')}</div>`
    : '';

  container.innerHTML = `
    <h3 class="modal-title">${title}</h3>
    <div class="modal-body">${content}</div>
    ${actionsHtml}
  `;

  // Wire up action buttons
  container.querySelectorAll('[data-action]').forEach(btn => {
    const idx = parseInt(btn.dataset.action);
    if (actions[idx] && actions[idx].onClick) {
      btn.addEventListener('click', () => actions[idx].onClick());
    }
  });

  overlay.classList.remove('hidden');

  // Close on backdrop click
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeModal();
  }, { once: true });
}

/**
 * Close the modal dialog.
 */
export function closeModal() {
  const overlay = document.getElementById('modal-overlay');
  if (overlay) overlay.classList.add('hidden');
}
